import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoCircular } from "@/shared/model/edo-circular.model";
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import { useEffect } from "react";
import { Translate } from "react-jhipster";
import { deleteEntity } from "../../../shared/reducers/entities/edo-circular.reducer";

interface DeleteCircularProps {
  circular: IEdoCircular | null;
  open: boolean;
  onClose: () => void;
}

const DeleteCircular = (props: DeleteCircularProps) => {
  const dispatch = useAppDispatch();
  const updateSuccess = useAppSelector<boolean>(
    (state) => state.edoCircular.updateSuccess
  );
  const { open, onClose: handleClose, circular } = props;

  const confirmDelete = () => {
    if (!circular) return;
    dispatch(deleteEntity(circular.id));
  };

  useEffect(() => {
    if (updateSuccess) handleClose();
  }, [updateSuccess, handleClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
          </DialogTitle>
        </DialogHeader>
        {circular && (
          <p className="text-body text-[var(--color-mockup-text-mid)]">
            <Translate
              contentKey="edocendoApp.edoCircular.delete.question"
              interpolate={{ nome: circular.title }}
            >
              Are you sure you want to delete this EdoCircolare?
            </Translate>
          </p>
        )}
        <DialogFooter>
          <Button variant="outline-solid" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete} disabled={!circular}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteCircular;
